import type React from 'react';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	return (
		<div className="container mt-10 px-2 md:mt-25">
			<PageHeading />
			<PageBody />
		</div>
	);
};
